// extracted by mini-css-extract-plugin
module.exports = {"twoColumns":"TwoColumns_twoColumns__SEMQ7"};